const styles = ({ palette, spacing }) => ({
  color: palette.error,
  padding: [spacing.sm, 0],
});

export default styles;
